import {Card, CardHeader, Heading, CardBody, Checkbox, FormLabel, FormControl, FormHelperText, Grid, Input, Stack, Text, Box, Divider,
	Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon} from '@chakra-ui/react'
import useAuthStore from 'stores/authStore'

export const UserForm = (props) => {
	const {values, handleChange} = props
	const user = useAuthStore((state) => state.user)
	console.log(props)
	return (
		<>
			<Card maxW='900px' w='100%' borderRadius='xl' boxShadow='sm'>
				<CardHeader pb='2'>
					<Heading size='md'>
							User information
					</Heading>
					<Text mt='1' fontSize='sm' color='gray.500'>
							Personal information and user permissions
					</Text>
				</CardHeader>
				<CardBody pt='4'>
					<Box>
						<Text fontSize='sm' fontWeight='bold' color='gray.600' textTransform='uppercase' letterSpacing='wide' mb='4'>
								Personal information
						</Text>
					<Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} gap='4'>

						<FormLabel>TZ</FormLabel>
							<Input name='identify' value={values.identify} onChange={handleChange} placeholder='Enter TZ'/>
						<FormLabel>Phone</FormLabel>
							<Input name='phone' value={values.phone} onChange={handleChange} placeholder='Enter phone number'/>
						<FormLabel>First Name</FormLabel>
							<Input name='name' value={values.name} onChange={handleChange} placeholder='Enter first name'/>
						<FormLabel>Last Name</FormLabel>
							<Input name='last_name' value={values.last_name} onChange={handleChange} placeholder='Enter last name'/>
						<FormLabel>Password</FormLabel>
							<Input name='password' value={values.password} onChange={handleChange} placeholder='Enter password'/>
					</Grid>
					</Box>

					<Divider my='6' />

				<Box>
						<Text fontSize='sm' fontWeight='bold' color='gray.600' textTransform='uppercase' letterSpacing='wide' mb='4'>
						User roles
						</Text>
					<Box borderWidth='1px' borderRadius='lg' p='4'>
						<Stack spacing='3'>
							<Checkbox isChecked={values.is_counter} name='is_counter' onChange={handleChange}>
								Counter
							</Checkbox>

							<Checkbox isChecked={values.is_shift_manager} name='is_shift_manager' onChange={handleChange}>
								Shift manager
							</Checkbox>

							<Checkbox isChecked={values.is_counting_manager} name='is_counting_manager' onChange={handleChange}>
								Counting manager
							</Checkbox>

							{user?.is_admin && (
								<Checkbox isChecked={values.is_admin} name='is_admin' onChange={handleChange}>
									Admin
								</Checkbox>
							)}
						</Stack>
					</Box>
				</Box>

					<Divider my='6' />

					<Accordion allowToggle>
						<AccordionItem border='none'>
							<h2>
								<AccordionButton px={0} py={3} borderBottom='1px solid' borderColor='gray.200'>
									<Box as='span' flex='1' textAlign='left' fontWeight='bold' fontSize='sm' color='gray.600' textTransform='uppercase' letterSpacing='wide'>
										Address information
									</Box>
								<AccordionIcon />
								</AccordionButton>
							</h2>
							<AccordionPanel px={0} pt={5}>
							<Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} gap='4'>
								<FormControl>
									<FormLabel>Country</FormLabel>
									<Input name='address.country' value={values.address?.country ?? ''} onChange={handleChange} placeholder='Country'/>
								</FormControl>
								
								<FormControl>
									<FormLabel >City</FormLabel>
									<Input name='address.city' value={values.address?.city ?? ''} onChange={handleChange} placeholder='City'/>
								</FormControl>

								<FormControl>
									<FormLabel>Street</FormLabel>
									<Input name='address.street' value={values.address?.street ?? ''} onChange={handleChange} placeholder='Street, № of house'/>
									<FormHelperText>Street, № of house</FormHelperText>
									<Input mt='4' name='address.flat' value={values.address?.flat ?? ''} onChange={handleChange} placeholder='Flat, office, floor'/>
									<FormHelperText>Flat, office, floor</FormHelperText>
								</FormControl>

								<FormControl>
									<FormLabel>Zip Code</FormLabel>
									<Input name='address.zipcode' value={values.address?.zipcode ?? ''} onChange={handleChange} placeholder='Zip code'/>
								</FormControl>
							</Grid>
							</AccordionPanel>
						</AccordionItem>
					</Accordion>
				</CardBody>
			</Card>
		</>
	)
}